export var Visibility;

(function (Visibility) {
  Visibility["Private"] = "Private";
  Visibility["Public"] = "Public";
})(Visibility || (Visibility = {}));

export var ConsumeStatus;

(function (ConsumeStatus) {
  ConsumeStatus["Confirmed"] = "Confirmed";
  ConsumeStatus["None"] = "None";
})(ConsumeStatus || (ConsumeStatus = {}));

export var Status;

(function (Status) {
  Status["Accepted"] = "Accepted";
  Status["Declined"] = "Declined";
  Status["Originated"] = "Originated";
  Status["RedeemedPartial"] = "RedeemedPartial";
  Status["RedeemedFull"] = "RedeemedFull";
  Status["Voided"] = "Voided";
  Status["None"] = "None";
})(Status || (Status = {}));

export var Add;

(function (Add) {
  Add["Confirmed"] = "Confirmed";
  Add["Pending"] = "Pending";
  Add["Denied"] = "Denied";
})(Add || (Add = {}));

export var ConsumeFrom; //WINE GIFT TYPES

(function (ConsumeFrom) {
  ConsumeFrom["None"] = "None";
  ConsumeFrom["Pending"] = "Pending";
})(ConsumeFrom || (ConsumeFrom = {}));